;(function() {
  'use strict'

  var dependencies = [
    'core.services',
    'core.filters',
    'core.factories',

    /*
         * Components
         */
    'core.auth',
    'core.cardElement',
    'core.cardReward',
    'core.cardSurvey',
    'core.communityDialog',
    'core.compileHtml',
    'core.cursor',
    'core.elementSelector',
    'core.faces',
    'core.fbLikeButton',
    'core.feed',
    'core.footer',
    'core.heroBanner',
    'core.imagePicker',
    'core.imageViewer',
    'core.pageSelector',
    'core.proSection',
    'core.share',
    'core.topbar',
    'core.unsupportedBrowser',
  ]

  angular.module('app.core', dependencies)

  // --------------------
})()
